<mat-spinner *ngIf="isLoading"></mat-spinner>
<div>
  <div *ngFor="let timeslot of availabilities" (click)="selectTimeslot(timeslot)" [class.selected]="selectedTimeslot === timeslot">{{ timeslot }}</div>
</div>
<div (click)="bookSelectedTimeslot()">BOOK NOW</div>
